const guiColors = {
    'motion-primary': '#4caf50',  // 主绿色
    'motion-primary-transparent': '#4caf50e6',
    'motion-tertiary': '#388e3c', // 深绿

    'looks-secondary': '#32b7a6',
    'looks-transparent': '#4caf5059',
    'looks-light-transparent': '#4caf5026',
    'looks-secondary-dark': 'hsla(122, 39%, 46%, 1)',

    'extensions-primary': 'hsla(122, 55%, 60%, 1)',
    'extensions-tertiary': 'hsla(122, 55%, 35%, 1)',
    'extensions-transparent': 'hsla(122, 55%, 60%, 0.35)',
    'extensions-light': 'hsla(122, 45%, 85%, 1)',

    'drop-highlight': '#81c784',  // 亮绿（用于高亮）
    'mode-toggle':'#78d6ac',

    'tabswitcher-tabs-equles':'#32b7a6',
    'tabswitcher-tabs-noequles':'#AEEEEE',
    'tabswitcher-programe-down':'#c9ffef',
    'tabswitcher-control-first':'#f8f8f8',
    'tabswitcher-control-second':'#f0ffff',
    'tabswitcher-control-third':'#e0f8f8',
    'tabswitcher-serial-second':'#e0f8e8',
    'ic-main-1': '#32b7a6',          // 主绿色（清爽不刺眼）
    'ic-main-light-2': '#4ade80',    // 浅绿
    'ic-main-light-very-3': '#dcfce7', // 很浅绿（接近背景）
    'ic-main-light-pluse-4': '#f0fdf4' // 极浅绿（几乎白）
};

const blockColors = {

};

export {
    guiColors,
    blockColors
};